// eslint-disable-next-line no-shadow
export enum TimeTrackingState {
  SAVE_TIME = 'save-time',
  KEEP_TRACKING = 'keep-tracking',
  DISCARD = 'discard',
  NOACTION = 'noaction',
  /** At a clinic with CCM care plan time on: stay on the chart, still timing, and write the note first. */
  WRITE_NOTE = 'write-note',
}
